const NAMED_ENTITIES: Record<string, string> = {
  '&nbsp;': ' ',
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&#39;': "'",
  '&apos;': "'",
  '&hellip;': '…',
  '&mdash;': '-',
  '&ndash;': '–',
};

function safeFromCodePoint(cp: number): string {
  try {
    return cp > 0 && cp <= 0x10ffff ? String.fromCodePoint(cp) : '';
  } catch {
    return '';
  }
}

function decodeEntities(s: string): string {
  let out = s.replace(/&(?:nbsp|amp|lt|gt|quot|#39|apos|hellip|mdash|ndash);/g, (m) => NAMED_ENTITIES[m] ?? m);
  out = out.replace(/&#(\d+);/g, (_m, d) => safeFromCodePoint(Number(d)));
  out = out.replace(/&#x([0-9a-fA-F]+);/g, (_m, h) => safeFromCodePoint(parseInt(h, 16)));
  return out;
}

export function cleanMessageText(raw: string | null | undefined): string {
  if (!raw) return '';
  let s = raw;

  // Quoted-printable soft line breaks: "=\r\n" / "=\n" join wrapped lines.
  s = s.replace(/=\r?\n/g, '');
  // Quoted-printable hex octets (=20, =C3 …): decode printable ASCII, else space.
  s = s.replace(/=([0-9A-Fa-f]{2})/g, (_m, h) => {
    const code = parseInt(h, 16);
    return code >= 0x20 && code < 0x7f ? String.fromCharCode(code) : ' ';
  });

  s = decodeEntities(s);

  // Strip zero-width (U+200B–U+200D), word-joiner (U+2060), BOM (U+FEFF),
  // soft hyphen (U+00AD).
  s = s.replace(/[​-‍⁠﻿­]/g, '');
  // NBSP (U+00A0) → normal space.
  s = s.replace(/ /g, ' ');
  // Drop control chars EXCEPT tab (\x09) and newline (\x0A).
  s = s.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7F]/g, '');
  s = s.replace(/\r\n?/g, '\n');
  s = s.replace(/[ \t]+\n/g, '\n');
  s = s.replace(/\n{3,}/g, '\n\n');
  s = s.replace(/ {2,}/g, ' ');

  return s.trim();
}

// Strip HTML to readable text (used only when a message has body_html but no
// plain part). NOT a security boundary - we never dangerouslySetInnerHTML the
// raw e-mail; we render the cleaned text in a pre-wrap node.
export function htmlToText(html: string): string {
  const noScriptStyle = html
    .replace(/<style[\s\S]*?<\/style>/gi, '')
    .replace(/<script[\s\S]*?<\/script>/gi, '');
  const withBreaks = noScriptStyle
    .replace(/<\/(?:p|div|tr|li|h[1-6])>/gi, '\n')
    .replace(/<br\s*\/?>/gi, '\n');
  const stripped = withBreaks.replace(/<[^>]+>/g, '');
  return cleanMessageText(stripped);
}

export function messageBodyText(bodyPlain: string | null, bodyHtml: string | null): string {
  if (bodyPlain && bodyPlain.trim()) return cleanMessageText(bodyPlain);
  if (bodyHtml && bodyHtml.trim()) return htmlToText(bodyHtml);
  return '';
}
